import {Component, Mixins, Watch} from 'vue-property-decorator';
import {AxiosPromise, CancelTokenSource} from 'axios';
import DescriptionsContainerMixin from '../DescriptionsContainerMixin';
import {AIEnum} from '@/enums/AIEnum';
import {difference, flattenDeep} from 'lodash';

@Component
export default class EditDialogMixin extends Mixins(DescriptionsContainerMixin) {
    protected dialog: boolean = false;
    protected loading: boolean = false;
    protected saving: boolean = false;
    protected cancelRequest: CancelTokenSource | null = null;
    protected options: any = null;
    protected data: any = null;
    protected valid: boolean = true;
    private aiEnum = AIEnum;
    private errors: {
        [key: string]: Array<string>;
    } | null = null;
    public errorKeyList: {
        [key: string]: string;
    } | null = null;

    get commonErrors() {
        if (this.errorKeyList && this.errors) {
            let commonKeys = difference(Object.keys(this.errors), Object.values(this.errorKeyList));
            if (commonKeys.length > 0) return flattenDeep(commonKeys.map(key => (this.errors as any)[key]));
        } else if (this.errors) return flattenDeep(Object.values(this.errors));
        return null;
    }

    @Watch('dialog')
    onValueChange(value: boolean) {
        if (value)
            this.$nextTick().then(() => {
                this.onClickOutside();
            });
    }

    open(data: any, options: any) {
        this.beforeOpen();
        this.options = options;
        this.init(data);
        this.dialog = true;
    }

    async openAsync(request: AxiosPromise, cancelRequest: CancelTokenSource, options: any) {
        this.beforeOpen();
        this.dialog = true;
        this.cancelRequest = cancelRequest;
        this.options = options;
        const timerId = setTimeout(() => {
            this.loading = true;
        }, 100);
        try {
            const {data} = await request;
            this.init(data);
        } catch (err) {
            console.log(err);
            this.close();
        } finally {
            clearTimeout(timerId);
            this.loading = false;
        }
    }

    save() {
        this.beforeSave();
        const form = this.$refs.form as any;
        if (!form) {
            console.warn('form ref not found at validation state');
        }
        this.valid = form.validate();
        if (this.valid) {
            this.afterValidateSuccess();
            if (typeof this.options.saveCallback == 'function') {
                this.saving = true;
                this.options.saveCallback(this.data);
            } else {
                console.warn('no saveCallback provided');
                this.close();
            }
        }
    }

    close() {
        this.beforeClose();
        this.dialog = false;
        if (this.loading && this.cancelRequest) {
            this.cancelRequest.cancel();
            this.cancelRequest = null;
        }
        setTimeout(() => {
            this.loading = false;
            this.options = null;
            this.saving = false;
            this.valid = true;
            this.descriptionsContainer = null;
            this.clear();
            this.afterClose();
        }, 175);
    }

    init(data: any) {
        this.data = data;
    }
    clear() {
        this.data = null;
    }

    onClickOutside() {
        const focusable = Array.from(document.querySelectorAll('.v-dialog__content'));
        const active = focusable.find(el => el.classList.contains('v-dialog__content--active'));
        active && (active as HTMLElement).focus();
    }

    beforeSave() {}

    beforeOpen() {}

    beforeClose() {}

    afterClose() {}

    setupErrors(errors: any) {
        this.errors = errors;
        this.saving = false;
    }

    afterValidateSuccess() {}
}
